import PropTypes from 'prop-types';
import React from 'react';

import { colors } from '../../../common/styles/style-constants';

const BetterSmile = ({ color }) => (
  <svg width="15" height="8" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.465 0H.535C.214 0 0 .213 0 .536 0 1.768.322 2.892.804 3.91c0 0 0 .055.054.055 1.233 2.41 3.75 4.018 6.642 4.018a7.467 7.467 0 0 0 6.642-4.073A7.388 7.388 0 0 0 15 .483c0-.27-.213-.483-.536-.483zM7.5 6.964c-2.143 0-4.072-1.071-5.196-2.678h10.447C11.573 5.893 9.643 6.964 7.5 6.964zm5.839-3.75H1.66c-.322-.642-.481-1.393-.59-2.143H13.93c-.107.75-.268 1.5-.59 2.143z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);
BetterSmile.defaultProps = {
  color: colors.blue,
};

BetterSmile.propTypes = {
  color: PropTypes.string,
};

export default BetterSmile;
